var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowsLeft = function SvgArrowsLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrows-left_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.063 637.219c-3.75 0-7.407-1.407-10.22-3.844L55.157 395.719c-6.469-5.625-7.125-15.469-1.5-21.938l1.5-1.5L326.75 134.625c6.469-5.625 16.313-4.969 21.938 1.5 2.437 2.813 3.843 6.469 3.843 10.219v121.125h606.094a15.524 15.524 0 0 1 15.563 15.562V484.97a15.524 15.524 0 0 1-15.563 15.562H352.531V621.75c0 8.531-6.937 15.469-15.469 15.469z"
  })));
};

export default SvgArrowsLeft;